import React, { useContext, useCallback } from 'react';

import AssignmentMapContext from 'modules/assignment-map/map/context';
import VehicleTypeFilter from 'components/ShipmentFilters/VehicleTypeFilter';

const Header = () => {
  const { vehicleTypeFilter, filterByVehicleType } = useContext(AssignmentMapContext);

  const handleChange = useCallback(
    (values) => {
      filterByVehicleType(values);
    },
    [filterByVehicleType]
  );

  return (
    <div>
      <VehicleTypeFilter value={vehicleTypeFilter} onChange={handleChange} />
    </div>
  );
};

export default Header;
